export default "__VITE_ASSET__BhunHZkz__"